import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import DateUtils from "@/helpers/DateUtils.js";
import GenerateRepeatItems from "@/components/optimization/generate-repeat/GenerateRepeatItems.vue";
import RepeatCron from "@/components/optimization/generate-repeat/RepeatCron.vue";
import RepeatTimeWindows from "@/components/optimization/generate-repeat/RepeatTimeWindows.vue";
import FloatingButtons from "@/views/FloatingButtons.vue";
import TimeCalendar from "@/components/shared/TimeCalendar.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export const generateRepeatMixin = {
	name: "GenerateRepeat",
	mixins: [generalPurposeMixin],
	components: {
		VuePerfectScrollbar,
		RepeatCron,
		GenerateRepeatItems,
		RepeatTimeWindows,
		FloatingButtons,
		TimeCalendar,
	},
	props: {
		activeTabRepeat: {
			type: Number,
			default: 0,
		},
		toggleAllSelectedInformation: {
			type: Function,
		},
	},
	data() {
		return {
			cronExpression: "",
			pickup_points_checked: [],
			delivery_points_checked: [],
			vehicles_checked: [],
			isSidebarCalendar: false,
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			time_window: {
				init_date: "",
				end_date: "",
				init_hour: "",
				end_hour: "",
			},
			cron_object: {
				cronDayWeek: "*",
				cronDayMonth: "*",
				cronMonth: "*",
				cronHour: "0",
				cronMinute: "0",
			},
		};
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
	computed: {
		standardInput() {
			return this.$store.state.moduleOptimization.standardInputList;
		},
		isDisabled() {
			let sumChecked =
				this.pickup_points_checked.length + this.delivery_points_checked.length + this.vehicles_checked.length;
			return sumChecked <= 0;
		},
	},
	mounted() {
		this.time_window = {
			init_date: moment(this.standardInput["global_config"].init_date).format(),
			end_date: moment(this.standardInput["global_config"].end_date).format(),
			init_hour: this.standardInput["global_config"].init_hour,
			end_hour: this.standardInput["global_config"].end_hour,
		};
	},
	methods: {
		generateRepeat() {
			this.time_window.init_date = DateUtils.toDefaultDateTime(this.time_window.init_date, "YYYY-MM-DD");
			this.time_window.end_date = DateUtils.toDefaultDateTime(this.time_window.end_date, "YYYY-MM-DD");
			const payload = {
				to_repeat: {
					...(this.pickup_points_checked.length > 0 ? {pickups: this.pickup_points_checked} : {}),
					...(this.delivery_points_checked.length > 0 ? {deliveries: this.delivery_points_checked} : {}),
					...(this.vehicles_checked.length > 0 ? {vehicles: this.vehicles_checked} : {}),
				},
				standard_input: this.standardInput,
				general_cron: this.cronExpression,
				general_time_window: this.time_window,
			};
			this.$store.dispatch("moduleOptimization/repetitionGeneration", payload).then((res) => {
				this.$store.commit("moduleOptimization/SET_STANDARD_INPUT", res);
				this.toggleAllSelectedInformation();
				this.closePopupGenerateRepeat();
				this.$vs.notify({
					color: "success",
					title: this.$t("GenerationOfRepetitions"),
					text: this.$t("RepetitionsHaveBeenGeneratedCorrectly"),
					time: 7000,
				});
				return res;
			});
		},
		getCronExpression(cron) {
			this.cronExpression = cron;
		},
		processData(items) {
			return items
				.filter((item) => item.checked)
				.map(({identification, cron, time_window_repeat}) => ({
					identification,
					...(cron && time_window_repeat ? {cron, time_window: time_window_repeat} : {}),
				}));
		},
		getPickupPoints(points) {
			this.pickup_points_checked = this.processData(points);
		},
		getDeliveryPoints(points) {
			this.delivery_points_checked = this.processData(points);
		},
		getVehicles(vehicles) {
			this.vehicles_checked = this.processData(vehicles);
		},
		closePopupGenerateRepeat() {
			this.$emit("closePopupEmit");
		},
	},
};
